import PageWrapper from "../../../components/PageWrapper/PageWrapper"
import arrowLeft from "../../../assets/icons/Arrows/arrow-narrow-left.png"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

const ChangeLanguage = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const options = [
    { code: "en", label: t("language.english") },
    { code: "no", label: t("language.norwegian") },
    { code: "uk", label: t("language.ukrainian") },
    { code: "pl", label: t("language.polish") },
  ]

  const setLang = async (lng) => {
    await i18n.changeLanguage(lng)
  }

  const current = i18n.language

  return (
    <PageWrapper
      title={t("language.title")}
      headerLeft={
        <button
          className="absolute left-0 inset-y-0 my-auto w-12 h-12 flex items-center justify-center z-10"
          onClick={() => navigate(-1)}
          aria-label="Back"
        >
          <img src={arrowLeft} alt="back" className="w-6 h-6 invert" />
        </button>
      }
      background="bg-dark-default"
    >
      <div className="bg-light-default rounded-[20px] overflow-hidden border border-light-default">
        {options.map((opt, idx) => (
          <div key={opt.code} className="bg-light-default">
            <button
              onClick={() => setLang(opt.code)}
              className="w-full h-16 px-5 flex items-center justify-between"
            >
              <span className="text-[16px] font-semibold text-dark-default">
                {opt.label}
              </span>
              {current?.startsWith(opt.code) ? (
                <span className="text-[18px] text-dark-default">✓</span>
              ) : null}
            </button>
            {idx < options.length - 1 && (
              <div className="h-px bg-black-t-lighten-5 mx-5" />
            )}
          </div>
        ))}
      </div>
    </PageWrapper>
  )
}

export default ChangeLanguage
